/**
 * Created by cedricgodefroy on 18/07/2017.
 */
/**
 * Created by cedricgodefroy on 18/07/2017.
 */
angular.module('FlexyBeautyApp.services').factory('ReportView', ['$filter', 'DataSourceFactory', 'ReportModelData', 'StatPeriodType', 'ReportTemporalAgregateFunctionType', 'EltReportType',
    function ($filter, DataSourceFactory, ReportModelData, StatPeriodType, ReportTemporalAgregateFunctionType, EltReportType) {
        var ReportView = function (reportModel, userChanges, taxMode, functionSolutionActivated, startModelId) {
            this.id = null;
            this.reportModelId = null;
            this.title = null;
            this.descriptionTitle = null;
            this.descriptionDetail = null;
            this.indexActifEltReport = null;
            this.eltsReport = null;
            this.mouseover = false;
            this.advanced = false;
            this.displayDescription = false;
            this.loading = false;
            this.dataSource = null;
            this.onTemplateOnly = false;
            this.primaryDataTypePeriodStat = StatPeriodType.CURRENT;
            this.businessPage = null;
            this.helpCenterArticlesId = null;

            this.reportModel = reportModel;
            this.userChanges = userChanges;
            this.isSolutionActivated = functionSolutionActivated;
            this.primaryDataDay = null;

            this.INDEX_EVALUATION_TAB = 0;
            this.INDEX_COMPARAISON_TAB = 1;
            this.INDEX_ZOOM_TAB = 2;

            if (this.reportModel) {
                this.loadDataFrom(this.reportModel, startModelId);
            }

            if (userChanges) {
                this.loadUserChanges();
            }

            this.createDataSource();
        };

        ReportView.prototype.setPrimaryDataTypePeriodStat = function (primaryDataTypePeriodStat) {
            this.primaryDataTypePeriodStat = primaryDataTypePeriodStat;
        };

        ReportView.prototype.loadDataFrom = function (reportModel, startModelId) {
            this.id = reportModel.id;
            this.reportModelId = reportModel.id;
            this.title = reportModel.title;
            this.descriptionTitle = reportModel.descriptionTitle;
            this.descriptionDetail = reportModel.descriptionDetail;
            this.indexActifEltReport = reportModel.indexActifEltReport;
            this.eltsReport = reportModel.eltsReport;
            this.advanced = reportModel.advanced;
            this.typeOfData = reportModel.typeOfData;
            this.onTemplateOnly = reportModel.onTemplateOnly;
            this.businessPage = reportModel.businessPage;
            if (reportModel.helpCenterArticles)// load according startModelId (flexymodel1 : coiffeur) or default
                this.helpCenterArticlesId = reportModel.helpCenterArticles[startModelId] ? reportModel.helpCenterArticles[startModelId] : reportModel.helpCenterArticles["default"];
        };

        ReportView.prototype.loadUserChanges = function () {
            if (this.userChanges.title)
                this.title = this.userChanges.title;
            if (this.userChanges.descriptionTitle)
                this.descriptionTitle = this.userChanges.descriptionTitle;
            if (this.userChanges.descriptionDetail)
                this.descriptionDetail = this.userChanges.descriptionDetail;
            if (this.userChanges.indexActifEltReport)
                this.indexActifEltReport = this.userChanges.indexActifEltReport;
            if (this.userChanges.primaryDataTypePeriodStat)
                this.primaryDataTypePeriodStat = this.userChanges.primaryDataTypePeriodStat;
        };

        ReportView.prototype.getChanges = function () {
            var changes = {};
            if (this.title !== this.reportModel.title) {
                changes.title = this.title;
            }
            if (this.descriptionTitle !== this.reportModel.descriptionTitle) {
                changes.descriptionTitle = this.descriptionTitle;
            }
            if (this.descriptionDetail !== this.reportModel.descriptionDetail) {
                changes.descriptionDetail = this.descriptionDetail;
            }
            if (this.indexActifEltReport !== this.reportModel.indexActifEltReport) {
                changes.indexActifEltReport = this.indexActifEltReport;
            }
            if (this.getDataSource() && this.getDataSource().currentPath.length > 1) {
                changes.currentCategorieId = this.getDataSource().currentPath[this.getDataSource().currentPath.length - 1].id;
            }
            if (this.getDataSource() && this.getDataSource().currentPath.length > 1) {
                changes.currentCategorieType = this.getDataSource().currentPath[this.getDataSource().currentPath.length - 1].constructor ? this.getDataSource().currentPath[this.getDataSource().currentPath.length - 1].constructor.name : null;
            }
            if (this.primaryDataTypePeriodStat) {
                changes.primaryDataTypePeriodStat = this.primaryDataTypePeriodStat;
            }
            return changes;
        };

        ReportView.prototype.createDataSource = function (taxMode, categorieId, categorieType) {
            var currentCategorieId = this.userChanges ? this.userChanges.currentCategorieId : categorieId,
                currentCategorieType = this.userChanges ? this.userChanges.currentCategorieType : categorieType;

            this.dataSource = DataSourceFactory.getInstance().createDataSource(this.reportModelId, currentCategorieId, currentCategorieType, taxMode, this.typeOfData);
        };

        ReportView.prototype.getDataSource = function () {
            return this.dataSource;
        };

        ReportView.prototype.onTabClick = function (idLabel) {
            if (idLabel === this.INDEX_EVALUATION_TAB || idLabel === this.INDEX_ZOOM_TAB) {
                this.setPrimaryDataTypePeriodStat(StatPeriodType.CURRENT);
            }
            this.indexActifEltReport = idLabel;
        };

        ReportView.prototype.getClone = function () {
            var clone = new ReportView(this.reportModel);
            clone.id = this.id;
            clone.title = this.title;
            clone.descriptionTitle = this.descriptionTitle;
            clone.descriptionDetail = this.descriptionDetail;
            clone.indexActifEltReport = this.indexActifEltReport;//default value
            clone.eltsReport = this.eltsReport;
            clone.advanced = this.advanced;
            clone.businessPage = this.businessPage;
            clone.isSolutionActivated = this.isSolutionActivated;
            clone.helpCenterArticlesId = this.helpCenterArticlesId;
            //clone.dataSource = this.dataSource.clone();

            return clone;
        }

        ReportView.prototype.isChanged = function () {
            if (this.reportModel) {
                return ((this.title != this.reportModel.title && (!this.userChanges || !this.userChanges.title)) ||
                    (this.userChanges && this.userChanges.title && this.userChanges.title != this.title));
            } else {
                return true;
            }
        };

        ReportView.prototype.isNavigationChanged = function () {
            if (this.reportModel) {
                return (
                    (this.getDataSource().currentPath.length > 1 && (!this.userChanges || !this.userChanges.currentCategorieId || this.getDataSource().currentCategory.id != this.userChanges.currentCategorieId)) ||
                    (this.getDataSource().currentPath[this.getDataSource().currentPath.length - 1].constructor &&
                        this.getDataSource().currentPath.length > 1 &&
                        (!this.userChanges || !this.userChanges.currentCategorieType || this.getDataSource().currentCategorieType != this.userChanges.currentCategorieType)) ||
                    (this.indexActifEltReport != this.reportModel.indexActifEltReport && (!this.userChanges || !this.userChanges.indexActifEltReport)) ||
                    (this.userChanges != null && this.userChanges.indexActifEltReport != null && this.userChanges.indexActifEltReport != this.indexActifEltReport)
                );
            } else {
                return true;
            }
        };

        ReportView.prototype.matchFilter = function (textFilter) {
            var matchFilter = true,
                textFilterNormalize = null,
                titleBNormalize = null;

            if (textFilter != null && textFilter != "") {

                if (this.title.normalize()) {
                    textFilterNormalize = textFilter.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();
                    titleBNormalize = this.title.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();
                } else {
                    textFilterNormalize = textFilter.toLowerCase();
                    titleBNormalize = this.title.toLowerCase();
                }

                if (titleBNormalize.indexOf(textFilterNormalize) === -1) {
                    matchFilter = false;
                }

            }
            return matchFilter;
        }

        ReportView.prototype.getPeriodStat = function (periodType) {
            return this.getDataSource().getPeriodStat(periodType);
        }

        ReportView.prototype.getPeriod = function (periodType) {
            return this.getDataSource().getPeriod(periodType);
        };

        ReportView.prototype.getCurrentPeriod = function () {
            return this.getDataSource().getPeriod(StatPeriodType.CURRENT);
        };

        ReportView.prototype.getCurrentPeriodType = function () {
            return this.getDataSource().getPeriod(StatPeriodType.CURRENT).type;
        };

        ReportView.prototype.getPastPeriod = function () {
            return this.getDataSource().getPeriod(StatPeriodType.PAST);
        };

        ReportView.prototype.getDataSourcePath = function () {
            return this.getDataSource().currentPath;
        };

        ReportView.prototype.hasCustomers = function () {
            return ((this.getDataSource().getPeriodStat(this.primaryDataTypePeriodStat) && this.getDataSource().getPeriodStat(this.primaryDataTypePeriodStat).customers && this.getDataSource().getPeriodStat(this.primaryDataTypePeriodStat).customers.length > 0));
        };

        ReportView.prototype.hasPrimaryDatas = function () {
            return ((this.getDataSource().getPeriodStat(this.primaryDataTypePeriodStat).primaryDatas && this.getDataSource().getPeriodStat(this.primaryDataTypePeriodStat).primaryDatas.length > 0) ||
                (this.getDataSource().getPeriodStat(this.primaryDataTypePeriodStat).nbPassageCustomers && this.getDataSource().getPeriodStat(this.primaryDataTypePeriodStat).nbPassageCustomers > 0));
        };

        ReportView.prototype.categoryHasSubCategoriesOnPeriod = function (category, period) {
            return (category.getSubStatCategories && category.getSubStatCategories(this.getDataSource().rootCategory, (period ? period.arrayOfDays : null)).length > 0);
        };

        ReportView.prototype.hasSubCategoriesOnPeriod = function (period) {
            return this.categoryHasSubCategoriesOnPeriod(this.getDataSource().currentCategory, period);
        };

        ReportView.prototype.getCurrentPeriodSubCategories = function () {
            return this.getDataSource().getCurrentPeriodStat().categorieTable;
        };

        ReportView.prototype.legendEvaluationSubCategoriesFilter = function (category) {
            return (this.getDataSource().zeroValueDisplayed() || (!this.getDataSource().zeroValueDisplayed() && this.getDataSource().getCurrentPeriodStat().getAgregationOfCategory(category) != 0));
        };

        ReportView.prototype.legendComparaisonSubCategoriesFilter = function (category) {
            return (this.getDataSource().zeroValueDisplayed() || (!this.getDataSource().zeroValueDisplayed() && (this.getDataSource().getCurrentPeriodStat().getAgregationOfCategory(category) != 0 || this.getDataSource().getPastPeriodStat().getAgregationOfCategory(category) != 0)));
        };

        ReportView.prototype.sortCurrentPeriodAgregationOfCategory = function (category) {
            return this.getDataSource().getCurrentPeriodStat().getAgregationOfCategory(category);
        };

        ReportView.prototype.getCurrentPeriodAgregationOfCategory = function (category) {
            return this.getDataSource().getCurrentPeriodStat().getAgregationOfCategory(category);
        };

        ReportView.prototype.getCurrentPeriodAgregationOfAllCategories = function (needAverageFromDetail) {

            var currentPeriodAgregationOfAllCategories = null;
            if (this.getDataSource() && this.getDataSource().getCurrentPeriodStat()) {
                //WARNING! TODO : CHANGER l'id en dur...
                if (this.reportModelId == 'average-cart-by-gender' && needAverageFromDetail) {
                    currentPeriodAgregationOfAllCategories = this.getDataSource().getCurrentPeriodStat().getAverageFromDetailLevel();
                } else {
                    currentPeriodAgregationOfAllCategories = this.getDataSource().getCurrentPeriodStat().getAgregationOfTotalCategory();
                }

            }
            return currentPeriodAgregationOfAllCategories;
        };

        ReportView.prototype.getPastPeriodAgregationOfCategory = function (category) {
            return this.getDataSource().getPastPeriodStat().getAgregationOfCategory(category);
        };

        ReportView.prototype.getPastPeriodAgregationOfAllCategories = function () {
            return this.getDataSource().getPastPeriodStat().getAgregationOfTotalCategory();
        };

        ReportView.prototype.getPeriodTypeOfCurrentPeriod = function () {
            return this.getDataSource().currentPeriod.periodType;
        };

        ReportView.prototype.getLabelOfCurrentPeriod = function () {
            return this.getDataSource().currentPeriod.getLabel();
        };

        ReportView.prototype.getBeginLabelOfCurrentPeriod = function () {
            return this.getDataSource().currentPeriod.getLabelBegin();
        };

        ReportView.prototype.getEndLabelOfCurrentPeriod = function () {
            return this.getDataSource().currentPeriod.getLabelEnd();
        };

        ReportView.prototype.getLabelOfPastPeriod = function () {
            return this.getDataSource().selectedPastPeriod.getLabel();
        };

        ReportView.prototype.getBeginLabelOfPastPeriod = function () {
            return this.getDataSource().selectedPastPeriod.getLabelBegin();
        };

        ReportView.prototype.getEndLabelOfPastPeriod = function () {
            return this.getDataSource().selectedPastPeriod.getLabelEnd();
        };

        ReportView.prototype.getCategoriesOnPeriods = function () {
            return this.getDataSource().getCategoriesOnPeriods();
        };

        ReportView.prototype.sortCategories = function (cat1, cat2) {
            return this.getDataSource().getCurrentPeriodStat().getAgregationOfCategory(cat1) < this.getDataSource().getCurrentPeriodStat().getAgregationOfCategory(cat2);
            ;
        };

        ReportView.prototype.onCategoryUpClick = function (category) {
            this.getDataSource().updatePath(category);
            this.getDataSource().loadCategory(category);
        };

        ReportView.prototype.eltReportViewHasDatas = function (eltReportView) {
            var hasDatas = false;
            if ((this.getCurrentPeriodAgregationOfAllCategories() && this.getCurrentPeriodAgregationOfAllCategories() != 0) ||
                (EltReportType.getEltReportTypeById(eltReportView.type) === EltReportType.COMPARE && this.getPastPeriodAgregationOfAllCategories() && this.getPastPeriodAgregationOfAllCategories() != 0)) {
                hasDatas = true;
            } else {
                if ((this.getDataSource().getCurrentPeriodStat() && this.getDataSource().getCurrentPeriodStat().hasDataOnCategories()) ||
                    (EltReportType.getEltReportTypeById(eltReportView.type) === EltReportType.COMPARE && this.getDataSource().getPastPeriodStat().hasDataOnCategories())) {
                    hasDatas = true;
                }
            }
            return hasDatas;
        };

        ReportView.prototype.setPrimaryDataDay = function (primaryDataDay) {
            this.primaryDataDay = primaryDataDay;
        };

        ReportView.prototype.filterDay = function (primaryData) {
            var matchDay = true,
                dayItem = null;

            if (this.primaryDataDay) {
                if (primaryData.day && primaryData.day.id) dayItem = primaryData.day.id;
                else if (primaryData.sale && primaryData.sale.day.id) dayItem = primaryData.sale.day.id;
                else if (primaryData.booking && primaryData.booking.day.id) dayItem = primaryData.booking.day.id;
                if (dayItem)
                    matchDay = (dayItem == this.primaryDataDay.id);
            }
            return matchDay;
        };

        return ReportView;
    }
]);



// WEBPACK FOOTER //
// ./js/services/views/statistics/report/ReportView.js